import SurveyAnswers from './SurveyAnswers';

export default SurveyAnswers;
